import React, {useState} from "react";
import GpParametres from "./GpParametres";
import GroupSettings from "./GroupSettings";

function parametres() {
    const [activeTab, setActiveTab] = useState("GpParametre");

    return (
        <div className='container-fluid'>

            <h2>GpParametre</h2>
            <br />

            <ul className="nav nav-tabs" id="myTab">
                <li className="nav-item">
                    <a
                        className={`nav-link${activeTab === "GpParametre" ? " active" : ""}`}
                        id="GpParametre-tab"
                        href="#GpParametre"
                        onClick={() => setActiveTab("GpParametre")}
                        role="tab"
                        aria-controls="GpParametre"
                        aria-selected={activeTab === "GpParametre"}
                    >
                        GpParametre
                    </a>
                </li>
                <li className="nav-item" key='group_settings-tab-li'>
                    <a
                        className={`nav-link${activeTab === "group_settings" ? " active" : ""}`}
                        id="group-settings-tab"
                        href="#group_settings"
                        onClick={() => setActiveTab("group_settings")}
                        role="tab"
                        aria-controls="group_settings"
                        aria-selected={activeTab === "group_settings"}
                    >
                        group_settings
                    </a>
                </li>
            </ul>

            {activeTab === "GpParametre" && (
                <div className='mt-3'>
                    <GpParametres />
                </div>
            )}
            {activeTab === "group_settings" && (
                <div className='mt-3'>
                    <GroupSettings />
                </div>
            )}
        </div>
    )
}

export default parametres;